import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import {agentDeveloperUtils} from 'wobi-web-common';

export const useStyles = makeStyles()(() => ({
  bannerWrapper: {
    position: 'sticky',
    top: 0,
    zIndex: 100000,
    backgroundColor: agentDeveloperUtils.getSecondaryColor(100),
    padding: '12px 16px',
    border: '1px solid #ccc',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '30px',
    marginTop: '-12px',
  },
  textContent: {
    textAlign: 'left',
  },
  title: {
    fontWeight: 700,
    fontSize: '16px',
    marginBottom: '4px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#333',
  },
  button: {
    color: agentDeveloperUtils.getPrimaryColor(450),
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '4px',
    textDecoration: 'underline',
  },
}));

const StickyTopBanner = ({ title, subtitle, buttonText, onButtonClick }) => {
  const { classes } = useStyles();
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className={classes.bannerWrapper}>
      <div className={classes.textContent}>
        <div className={classes.title}>{title}</div>
        <div className={classes.subtitle}>{subtitle}</div>
        {buttonText && (
          <div className={classes.button} onClick={() => {
            onButtonClick();
            setVisible(false);
          }
          }>
            {buttonText}
          </div>
        )}
      </div>
      <IconButton
        aria-label="Close banner"
        onClick={() => setVisible(false)}
        size="very-small"
        style={{ padding: 0, marginLeft: 'auto' }}
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
};

export default StickyTopBanner;
